export default {
  state: {
   data: {}
  },
  mutations: {
    setDoyen(state, data) {
      state.data = Object.assign({}, data )
    },
    changeTopic(state,{ index, topic }) {
      state.data.list.splice(index, 1, topic)
    }
  },
  getters: {
    list : state => {
      return state.data.list;
    },
    answers: state => {
      return state.data.answer
    }
  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/doyen.js